<div class="container-fluid mt-4 ps-4">
  <div class="row justify-content-between">
    <div class="col-5">
      <h2 class="mb-4">{{ title }}</h2>
    </div>
  </div>

  @if (columnRulesReady) {
    <div class="row">
      <div class="col-12 pt-3 vh-100">
        <app-ap-vendors-grid
          [gridName]="'ClientApVendors'"
          [suppliedQueryData]="suppliedGridQueryData"
          [(reloadGridData)]="reloadGrid"
          [FilterModel]="FilterModel"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [getCalculatedColumnActions]="calculatedColumnActions"
          [getCalculatedColumnTooltipMap]="calculateColumnTooltipMap"
          [defaultHiddenColumns]="defaultHiddenColumns"
          [suppressedColumns]="suppressedColumns"
          [suppressFieldDotNotation]="false"
          (actionEvent)="action($event)"
        ></app-ap-vendors-grid>
      </div>
    </div>
  }
</div>
